import React from 'react';
import PropTypes from 'prop-types';

// Icon
const DeleteIcon = ({ className, width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 240 240"
  >
    <g>
      <path
        className="icon deleteIcon"
        fill={fill}
        d="M189.229,28.023c4.789,0,8.871,1.685,12.24,5.054c3.369,3.369,5.055,7.451,5.055,12.241v11.455	c0,3.745-1.086,7.095-3.258,10.051c-2.172,2.958-4.94,5.036-8.311,6.233v144.761c0,4.717-1.684,8.76-5.053,12.129	s-7.412,5.054-12.129,5.054h-115c-4.792,0-8.872-1.685-12.241-5.054c-3.369-3.369-5.054-7.412-5.054-12.129V73.058	c-3.295-1.197-6.028-3.274-8.198-6.233c-2.172-2.957-3.257-6.307-3.257-10.051V45.318c0-4.791,1.685-8.872,5.054-12.241	c3.369-3.369,7.412-5.054,12.129-5.054h40.317v-5.728c0-4.791,1.685-8.872,5.054-12.241C99.946,6.685,103.989,5,108.706,5h23.022	c4.789,0,8.871,1.685,12.24,5.054c3.369,3.369,5.055,7.451,5.055,12.241v5.728H189.229z M194.955,56.773V45.318		c0-1.572-0.561-2.92-1.684-4.043s-2.472-1.685-4.043-1.685H51.206c-1.572,0-2.92,0.562-4.043,1.685s-1.685,2.471-1.685,4.043	v11.455c0,1.572,0.562,2.92,1.685,4.043s2.471,1.685,4.043,1.685h138.022c1.572,0,2.92-0.562,4.043-1.685		S194.955,58.346,194.955,56.773z M177.773,223.546c1.572,0,2.92-0.562,4.043-1.685s1.684-2.471,1.684-4.043V74.068H57.045v143.75	c0,1.572,0.562,2.92,1.685,4.043s2.471,1.685,4.043,1.685H177.773L177.773,223.546z M85.795,85.523c1.572,0,2.92,0.562,4.043,1.685	s1.685,2.471,1.685,4.043v115c0,1.647-0.562,3.032-1.685,4.155s-2.471,1.685-4.043,1.685c-1.648,0-3.032-0.562-4.155-1.685 s-1.685-2.508-1.685-4.155v-115c0-1.572,0.562-2.92,1.685-4.043S84.147,85.523,85.795,85.523z M102.978,22.296v5.728h34.477v-5.728	c0-1.572-0.561-2.92-1.684-4.043s-2.472-1.685-4.043-1.685h-23.023c-1.572,0-2.92,0.562-4.043,1.685S102.978,20.724,102.978,22.296		z M120.273,85.523c1.573,0,2.92,0.562,4.043,1.685S126,89.679,126,91.251v115c0,1.647-0.561,3.032-1.684,4.155		s-2.471,1.685-4.043,1.685c-1.572,0-2.92-0.562-4.043-1.685s-1.685-2.508-1.685-4.155v-115c0-1.572,0.562-2.92,1.685-4.043		S118.701,85.523,120.273,85.523z M154.75,85.523c1.572,0,2.92,0.562,4.043,1.685s1.686,2.471,1.686,4.043v115		c0,1.647-0.563,3.032-1.686,4.155s-2.471,1.685-4.043,1.685s-2.92-0.562-4.043-1.685s-1.684-2.508-1.684-4.155v-115		c0-1.572,0.561-2.92,1.684-4.043S153.178,85.523,154.75,85.523z"
      />
    </g>
  </svg>
);

DeleteIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

DeleteIcon.defaultProps = {
  height: '100%',
  fill: 'currentColor',
};

export default DeleteIcon;
